import React, { Children } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookSquare, faLinkedin, faTwitterSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'gatsby';

import Heading from '../Heading';
import LayoutPageWrapper from '../LayoutPageWrapper';
import Logo from '../Logo';
import styles from './index.module.css';
import grid from '../../design-language/3rd-party/flexboxgrid.module.css';

const SocialLink = ({ icon, link, title }) => (
  <li>
    <a href={link} target="_blank" className={styles.footerSocialIcon} title={title}>
      <FontAwesomeIcon
        icon={icon}
        size="lg"
      />
    </a>
  </li>
);

const FooterColumn = ({ children, heading }) => (
  <div className={classnames(grid.colXs6, grid.colSm3)}>
    <Heading type="h6" size="XSmall">{heading}</Heading>
    <ul className={styles.footerLinks}>
      {Children.map(children, child => <li>{child}</li>)}
    </ul>
  </div>
)

const Footer = () => (
  <footer className={styles.footer}>
    <section>
      <LayoutPageWrapper gridRow horizontalPadding="Medium">
        <div className={classnames(grid.row,grid.colXs12, grid.colSm4)}>
          <div className={styles.footerLogoWrapper}>
            <Logo />
          </div>
        </div>
        <div className={classnames(grid.colXs12, grid.colSm8)}>
          <nav className={grid.row}>
            <FooterColumn heading="Product">
              <Link to="/why-endtest"  title="Why Endtest?">Why Endtest?</Link>
              <Link to="/enterprise" title="Enterprise">Enterprise</Link>
              <Link to="/security" title="Security">Security</Link>
              <Link to="/customer-service" title="Customer Service">Customer Service</Link>
              <a href="https://endtest.io/pricing.htm" title="Pricing">Pricing</a>
              <Link to="/endtest-demo" title="Endtest Demo">Endtest Demo</Link>
              <Link to="/selenium-alternative" title="Selenium Alternative">Selenium Alternative</Link>
            </FooterColumn>
            <FooterColumn heading="Components">
              <a href="https://endtest.io/guides/docs/how-to-create-web-tests/" title="Web Tests">Web Tests</a>
              <a href="https://endtest.io/guides/docs/how-to-create-mobile-tests/" title="Mobile Tests">Mobile Tests</a>
              <a href="https://endtest.io/guides/docs/how-to-use-the-scheduler/" title="Scheduler">Scheduler</a>
              <a href="https://endtest.io/guides/docs/computer-vision/" title="Computer Vision">Computer Vision</a>
              <a href="https://endtest.io/guides/docs/automatic-backup/" title="Backups">Backups</a>
              <a href="https://endtest.io/guides/docs/drive/" title="Drive">Drive</a>
              <a href="https://endtest.io/guides/docs/how-to-test-emails/" title="Mailbox">Mailbox</a>
            </FooterColumn>
            <FooterColumn heading="Resources">
              <a href="https://endtest.io/guides/docs/how-to-create-web-tests/" title="Documentation">Documentation</a>
              <a href="https://endtest.io/faq" title="FAQ">FAQ</a>
              <a href="https://endtest.io/subprocessors" title="Subprocessors">Subprocessors</a>
              <a href="https://endtest.io/guides/docs/how-to-use-the-endtest-api/" title="Endtest API">Endtest API</a>
              <a href="https://endtest.io/guides/docs/self-healing-tests/" title="Machine Learning">Machine Learning</a>
            </FooterColumn>
            <FooterColumn heading="Company">
              <Link to="/about-us" title="About Us">About Us</Link>
              <a target="_blank" href="https://endtest.io/guides/blog/" title="Blog">Blog</a>
                <Link to="/media-kit" title="Media Kit">Media Kit</Link>
                <a href="https://endtest.io/contact" title="Contact Us">Contact Us</a>
            </FooterColumn>
          </nav>
        </div>
      </LayoutPageWrapper>
    </section>
    <section className={styles.footerEnd}>
      <LayoutPageWrapper horizontalPadding="Small">
        <nav className={styles.footerEndContent}>
          <ul className={styles.footerEndLinks}>
            <li><a href="https://endtest.io/status.htm" title="Status">Status</a></li>
            <li><Link to="/terms" title="Terms of Service">Terms of Service</Link></li>
            <li><Link to="/privacy" title="Privacy Policy">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" title="Cookie Policy">Cookie Policy</Link></li>
            <li><Link to="/dpa" title="Data Processing Agreement">DPA</Link></li>
            <li><a href="https://endtest.io/contact" title="Contact Us">Contact Us</a></li>
          </ul>
          <ul className={styles.footerEndSocial}>
            <SocialLink icon={faFacebookSquare} link="http://facebook.com/Endtest" title="Endtest on Facebook"/>
            <SocialLink icon={faLinkedin} link="https://www.linkedin.com/company/endtest" title="Endtest on Linkedin" />
            <SocialLink icon={faTwitterSquare} link="http://twitter.com/endtest_io" title="Endtest on Twitter"/>
            <SocialLink icon={faYoutubeSquare} link="https://www.youtube.com/c/endtestio" title="Endtest on YouTube"/>
          </ul>
        </nav>
      </LayoutPageWrapper>
    </section>
  </footer>
);

export default Footer;
